/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import {
  Email,
  isEmail,
  ScreenName,
  isScreenName,
  Timestamp,
  isTimestamp,
  UnencryptedPassword,
  isUnencryptedPassword,
  UserId,
  isUserId,
  WorkspaceId,
  isWorkspaceId,
} from "../core/types.generated";
import {
  RoleV1,
  isRoleV1,
  RoleV2,
  isRoleV2,
} from "../permission/types.generated";
import { UserRef, isUserRef } from "../user/types.generated";
import { Tagged, bridgesIsTaggedHack as isTagged } from "@cartographerio/util";

export type InvitationId = Tagged<"InvitationId">;

export interface Invitation<R> {
  firstName: string;
  lastName: string;
  email: Email;
  workspaceId?: WorkspaceId | null;
  invitedBy: UserRef;
  roles: R[];
  created: Timestamp;
  expires?: Timestamp | null;
  accepted?: Timestamp | null;
  canceled?: Timestamp | null;
  id: InvitationId;
}

export type InvitationV1 = Invitation<RoleV1>;

export type InvitationV2 = Invitation<RoleV2>;

export interface InvitationCreate<R> {
  firstName: string;
  lastName: string;
  email: Email;
  workspaceId?: WorkspaceId | null;
  invitedBy: UserRef;
  roles: R[];
}

export type InvitationCreateV1 = InvitationCreate<RoleV1>;

export type InvitationCreateV2 = InvitationCreate<RoleV2>;

export type InvitationStatus = "Accepted" | "Canceled" | "Expired" | "Pending";

export interface InvitationExpired {
  invitationId: InvitationId;
}

export interface InvitationAlreadyAccepted {
  invitationId: InvitationId;
}

export interface SignupRequired {
  invitationId: InvitationId;
  firstName: string;
  lastName: string;
  email: Email;
}

export type InvitationAcceptChallenge =
  | ({ type: "InvitationAlreadyAccepted" } & InvitationAlreadyAccepted)
  | ({ type: "InvitationExpired" } & InvitationExpired)
  | ({ type: "SignupRequired" } & SignupRequired);

export interface InvitationAccepted {
  invitationId: InvitationId;
  userId: UserId;
}

export type InvitationAcceptResponse =
  | InvitationAcceptChallenge
  | ({ type: "InvitationAccepted" } & InvitationAccepted);

export interface Signup {
  firstName: string;
  lastName: string;
  email: Email;
  screenName: ScreenName;
  password: UnencryptedPassword;
  acceptTerms: boolean;
}

export const isInvitationId = (v: any): v is InvitationId => {
  return isTagged((a0: any): a0 is "InvitationId" => a0 === "InvitationId")(v);
};

export const isInvitation =
  <R>(isR: (r: any) => r is R) =>
  (v: any): v is Invitation<R> => {
    return (
      typeof v === "object" &&
      v != null &&
      "firstName" in v &&
      typeof v.firstName === "string" &&
      "lastName" in v &&
      typeof v.lastName === "string" &&
      "email" in v &&
      isEmail(v.email) &&
      (!("workspaceId" in v) ||
        isWorkspaceId(v.workspaceId) ||
        v.workspaceId === null) &&
      "invitedBy" in v &&
      isUserRef(v.invitedBy) &&
      "roles" in v &&
      Array.isArray(v.roles) &&
      v.roles.every((i: any) => isR(i)) &&
      "created" in v &&
      isTimestamp(v.created) &&
      (!("expires" in v) || isTimestamp(v.expires) || v.expires === null) &&
      (!("accepted" in v) || isTimestamp(v.accepted) || v.accepted === null) &&
      (!("canceled" in v) || isTimestamp(v.canceled) || v.canceled === null) &&
      "id" in v &&
      isInvitationId(v.id)
    );
  };

export const isInvitationV1 = (v: any): v is InvitationV1 => {
  return isInvitation((a0: any): a0 is RoleV1 => isRoleV1(a0))(v);
};

export const isInvitationV2 = (v: any): v is InvitationV2 => {
  return isInvitation((a0: any): a0 is RoleV2 => isRoleV2(a0))(v);
};

export const isInvitationCreate =
  <R>(isR: (r: any) => r is R) =>
  (v: any): v is InvitationCreate<R> => {
    return (
      typeof v === "object" &&
      v != null &&
      "firstName" in v &&
      typeof v.firstName === "string" &&
      "lastName" in v &&
      typeof v.lastName === "string" &&
      "email" in v &&
      isEmail(v.email) &&
      (!("workspaceId" in v) ||
        isWorkspaceId(v.workspaceId) ||
        v.workspaceId === null) &&
      "invitedBy" in v &&
      isUserRef(v.invitedBy) &&
      "roles" in v &&
      Array.isArray(v.roles) &&
      v.roles.every((i: any) => isR(i))
    );
  };

export const isInvitationCreateV1 = (v: any): v is InvitationCreateV1 => {
  return isInvitationCreate((a0: any): a0 is RoleV1 => isRoleV1(a0))(v);
};

export const isInvitationCreateV2 = (v: any): v is InvitationCreateV2 => {
  return isInvitationCreate((a0: any): a0 is RoleV2 => isRoleV2(a0))(v);
};

export const isInvitationStatus = (v: any): v is InvitationStatus => {
  return (
    v === "Accepted" || v === "Canceled" || v === "Expired" || v === "Pending"
  );
};

export const isInvitationExpired = (v: any): v is InvitationExpired => {
  return (
    typeof v === "object" &&
    v != null &&
    "invitationId" in v &&
    isInvitationId(v.invitationId)
  );
};

export const isInvitationAlreadyAccepted = (
  v: any
): v is InvitationAlreadyAccepted => {
  return (
    typeof v === "object" &&
    v != null &&
    "invitationId" in v &&
    isInvitationId(v.invitationId)
  );
};

export const isSignupRequired = (v: any): v is SignupRequired => {
  return (
    typeof v === "object" &&
    v != null &&
    "invitationId" in v &&
    isInvitationId(v.invitationId) &&
    "firstName" in v &&
    typeof v.firstName === "string" &&
    "lastName" in v &&
    typeof v.lastName === "string" &&
    "email" in v &&
    isEmail(v.email)
  );
};

export const isInvitationAcceptChallenge = (
  v: any
): v is InvitationAcceptChallenge => {
  return (
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "InvitationAlreadyAccepted" &&
      isInvitationAlreadyAccepted(v)) ||
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "InvitationExpired" &&
      isInvitationExpired(v)) ||
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "SignupRequired" &&
      isSignupRequired(v))
  );
};

export const isInvitationAccepted = (v: any): v is InvitationAccepted => {
  return (
    typeof v === "object" &&
    v != null &&
    "invitationId" in v &&
    isInvitationId(v.invitationId) &&
    "userId" in v &&
    isUserId(v.userId)
  );
};

export const isInvitationAcceptResponse = (
  v: any
): v is InvitationAcceptResponse => {
  return (
    isInvitationAcceptChallenge(v) ||
    (typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "InvitationAccepted" &&
      isInvitationAccepted(v))
  );
};

export const isSignup = (v: any): v is Signup => {
  return (
    typeof v === "object" &&
    v != null &&
    "firstName" in v &&
    typeof v.firstName === "string" &&
    "lastName" in v &&
    typeof v.lastName === "string" &&
    "email" in v &&
    isEmail(v.email) &&
    "screenName" in v &&
    isScreenName(v.screenName) &&
    "password" in v &&
    isUnencryptedPassword(v.password) &&
    "acceptTerms" in v &&
    typeof v.acceptTerms === "boolean"
  );
};

/* eslint-enable @typescript-eslint/explicit-module-boundary-types */
/* eslint-enable @typescript-eslint/no-use-before-define */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable @typescript-eslint/no-explicit-any */
/* eslint-enable @typescript-eslint/no-empty-interface */
